import styled from 'styled-components';
import GenericEmptyWatermark from './EmptyWatermark';

export const EmptyWatermark = styled(GenericEmptyWatermark)`
  padding-top: 82px;
`;
